import ValidateService from '@/services/ValidateService'

export function getEmailError(email: string): string {
  const trimmedEmail = email.trim()

  if (!trimmedEmail) {
    return 'Email is required'
  }

  if (!ValidateService.email(trimmedEmail)) {
    return 'Invalid email format'
  }

  return ''
}
